export const APP_BANNER_LOCAL_STORAGE_KEY = "circle-app-banner";

export const ONE_DAY_DURATION = 1000 * 60 * 60 * 24;
export const DAYS_APP_BANNER_SHOULD_BE_HIDDEN = 15;

export const MOBILE_REGEX =
  /Android|webOS|Nokia|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const ANDROID_OS_REGEX = /Android/i;
